import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../../api';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const [terms, setTerms] = useState({
    title: 'Terms and Conditions',
    content: '',
    lastUpdated: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTerms();
  }, []);

  const handleClose = () => {
    try {
      const hasHistory = window.history.length > 1;
      const hasSameOriginReferrer =
                document.referrer &&
                new URL(document.referrer).origin === window.location.origin;
      if (hasSameOriginReferrer || hasHistory) {
        navigate(-1);
      } else {
        navigate('/'); // fallback to home if opened from email/new tab
      }
    } catch {
      navigate('/');
    }
  };

  const fetchTerms = async () => {
    try {
      const response = await axios.get(api.getPolicyContent('terms-conditions'));
      if (response.data.exists) {
        setTerms({
          title: response.data.title || 'Terms and Conditions',
          content: response.data.content || '',
          lastUpdated: response.data.lastUpdated,
        });
      } else {
        setTerms({
          title: 'Terms and Conditions',
          content: 'Terms and Conditions content will be available soon.',
          lastUpdated: null,
        });
      }
    } catch (error) {
      console.error('Error fetching terms and conditions:', error);
      setTerms({
        title: 'Terms and Conditions',
        content: 'Unable to load terms and conditions. Please try again later.',
        lastUpdated: null,
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not available';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  if (loading) {
    return (
      <div className="tac-container">
        <button
          type="button"
          className="tac-close-btn"
          onClick={handleClose}
        >
                    ×
        </button>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <p>Loading Terms and Conditions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tac-container">
      <button
        type="button"
        className="tac-close-btn"
        aria-label="Close Terms and Conditions"
        title="Close"
        onClick={handleClose}
      >
                ×
      </button>
      <h1 className="tac-heading">{terms.title}</h1>
      <p className="tac-date">Last updated: {formatDate(terms.lastUpdated)}</p>

      <div 
        className="tac-content"
        dangerouslySetInnerHTML={{ __html: terms.content || 'Terms and Conditions content will be available soon.' }}
      />
    </div>
  );
};

export default TermsAndConditions;
